<script setup lang="ts">
definePageMeta({
  name: "article",
  layout: "article",
})

const productContent = useProductContentStore()
const personalization = usePersonalizationStore()

watch(
  () => productContent.activeArticle,
  () => {
    personalization.activeArticle = productContent.activeArticle
  },
  { immediate: true },
)

onUnmounted(() => {
  personalization.activeArticle = undefined
})
</script>

<template>
  <div>
    <UDynamicArticle
      v-if="productContent.activeArticle"
      :data="productContent.activeArticle"
    />
    <div class="fixed right-0 top-0">
      <UFeatureFlag>
        <div
          class="bg-platform-paper font-national2compressed text-sm text-black"
        >
          {{ personalization.elapsedSeconds }} s
        </div>
      </UFeatureFlag>
    </div>
  </div>
</template>
